// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"2359a1a6","186":"fe54177b","344":"933b737b","372":"83486dd5","377":"0898ec98","738":"a78b4084","841":"3a37d570","856":"b464f554","858":"b1969448"}[chunkId] + ".chunk.js";
};